import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Styless
import * as S from "./styles";

interface TabPanelProps {
	children?: React.ReactNode;
	index: any;
	value: any;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} aria-labelledby={`kotab-tab-${index}`} {...other}>
			{value === index && (
				<Box p={0}>
					<Typography component="span">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

interface IKogTabsComponent {
	tabCurrent: number;
	tabPanels: {
		tab: string;
		tabLabel?: React.ReactNode;
		panel: React.JSX.Element;
		isShowControl: boolean;
	}[];
	onChangeTab: (tabCurrent: number) => void;

	customWidth?: string;
}

export function KogTabsComponent({ tabPanels, tabCurrent, customWidth, onChangeTab = () => {} }: IKogTabsComponent) {
	const [value, setValue] = React.useState(tabCurrent);
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
		onChangeTab(newValue);
	};

	useEffect(() => {
		setValue(tabCurrent);
	}, [tabCurrent]);
	return (
		<S.BoxTabel>
			<AppBar position="static">
				<Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
					{tabPanels
						.filter((x) => x.isShowControl)
						.map((tabPanel, index) => (
							<Tab
								key={tabPanel.tab}
								label={tabPanel.tabLabel ?? tabPanel.tab}
								aria-controls={`kogtab-tabpanel-${index}`}
								style={customWidth ? { minWidth: customWidth } : {}}
								id={`id-register-tab-${tabPanel.tab.replace(/\s+/g, "")}`}
							/>
						))}
				</Tabs>
			</AppBar>
			{tabPanels
				.filter((x) => x.isShowControl)
				.map((tabPanel, index) => (
					<TabPanel key={`tabPanel-${index}`} value={value} index={index}>
						{tabPanel.panel}
					</TabPanel>
				))}
		</S.BoxTabel>
	);
}
